import React from 'react'
import HomeLanding from './HomeLanding'
import Project from './Project'
import About from './About'

const Home = () => {
  return (
    <>
      <HomeLanding />

      <Project />
      <About />
    </>
  )
}

export default Home
